








import { Component, Vue } from 'vue-property-decorator';
import layout from '@/layouts/basic-layout.vue';
import LoginForm from '@/components/login-form.vue';

@Component({
    components: {
        layout,
        'login-form': LoginForm,
    },
})
export default class Login extends Vue {}
